import React from 'react';
import { HiLightBulb, HiExclamationTriangle } from 'react-icons/hi2';

export default function GTMInsights({ issues = [], suggestions = [] }) {
  return (
    <div className="grid gap-4 md:grid-cols-2">
      <div className="rounded-xl border border-yellow-200 bg-yellow-50 p-4">
        <div className="mb-2 flex items-center gap-2 text-yellow-800">
          <HiExclamationTriangle className="h-5 w-5" />
          <h4 className="font-semibold">Issues identified</h4>
        </div>
        {issues.length === 0 ? (
          <p className="text-sm text-yellow-900">No issues detected.</p>
        ) : (
          <ul className="list-disc space-y-1 pl-5 text-sm text-yellow-900">
            {issues.map((i, idx) => (
              <li key={i.key || idx}>{i.message || String(i)}</li>
            ))}
          </ul>
        )}
      </div>
      <div className="rounded-xl border border-blue-200 bg-blue-50 p-4">
        <div className="mb-2 flex items-center gap-2 text-blue-800">
          <HiLightBulb className="h-5 w-5" />
          <h4 className="font-semibold">Suggestions</h4>
        </div>
        {suggestions.length === 0 ? (
          <p className="text-sm text-blue-900">Looks good. No suggestions right now.</p>
        ) : (
          <ul className="list-disc space-y-1 pl-5 text-sm text-blue-900">
            {suggestions.map((s, idx) => (
              <li key={s.key || idx}>{s.message || String(s)}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
